import type { ChatMessage } from './chatTypes'

/**
 * Feedback belongs to the final visual item in an assistant response cluster,
 * while its saved state lives on the persisted assistant text message.
 */
export function computeFeedbackPositions(messages: ChatMessage[]): Map<number, ChatMessage> {
  const result = new Map<number, ChatMessage>()

  let i = 0
  while (i < messages.length) {
    const msg = messages[i]

    if (msg.role === 'user') {
      i++
      continue
    }

    let clusterEnd = i
    let feedbackMsg: ChatMessage | null = null

    while (clusterEnd < messages.length && messages[clusterEnd].role !== 'user') {
      const current = messages[clusterEnd]
      if (current.type === 'text' && current.showFeedback) {
        feedbackMsg = current
      }
      clusterEnd++
    }

    if (feedbackMsg && clusterEnd > i) {
      result.set(clusterEnd - 1, feedbackMsg)
    }

    i = clusterEnd
  }

  return result
}
